import React, { useState } from 'react';
import InlineSelect from '@components/atoms/inline-select/inline-select';
import { ListingContext } from '@context/listing.context';
import { useContextSelector } from 'use-context-selector';
import styles from '../index.module.scss';
import BrandsMenu from './brands-menu';

const DROPDOWN_HEIGHT = 330;

const BrandSelect: React.FC = (): React.JSX.Element => {
  const [closeMenu, setCloseMenu] = useState<boolean>(false);
  const { listingDraftPayload, brandLabel, setPricingCalculatorInputTouched, setShowDefaultPricingCalculatorMessage } =
    useContextSelector(ListingContext, (state) => state);

  return (
    <div className={styles.formSentence__text}>
      <InlineSelect
        selectedItemLabel={brandLabel}
        containerPosition="static"
        dropdownHeight={DROPDOWN_HEIGHT}
        noScroll={true}
        setIsTouched={setPricingCalculatorInputTouched}
        setMessageState={setShowDefaultPricingCalculatorMessage}
        disabled={!listingDraftPayload.category}
        closeMenu={closeMenu}
        setCloseMenu={setCloseMenu}
        typeName="brand"
      >
        <BrandsMenu setCloseMenu={setCloseMenu} />
      </InlineSelect>
    </div>
  );
};

export default BrandSelect;
